import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import Input from "../../shared/components/Input";
import useForm from "../../shared/hooks/form-hooks";
import {
	VALIDATOR_NUMBER_ONLY,
	VALIDATOR_REQUIRE,
	VALIDATOR_VALIDATED,
} from "../../shared/util/validators";

import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import axios from "axios";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";

const EditStation = (props) => {
	const [isLoading, setIsLoading] = useState(false);
	const auth = useContext(AuthContext);
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();

	const [formState, inputHandler, setFormData] = useForm(
		{
			stationName: {
				value: props.stationName,
				isValid: false,
			},
			oneJaw1To7: {
				value: props.oneJaw1To7,
				isValid: false,
			},
			twoJaw1To7: {
				value: props.twoJaw1To7,
				isValid: false,
			},
			oneJaw7To14: {
				value: props.oneJaw7To14,
				isValid: false,
			},
			twoJaw7To14: {
				value: props.twoJaw7To14,
				isValid: false,
			},
			twoJaw14To21: {
				value: props.twoJaw14To21,
				isValid: false,
			},
			twoJaw21To28: {
				value: props.twoJaw21To28,
				isValid: false,
			},
			oneJawFull: {
				value: props.oneJawFull,
				isValid: false,
			},
			twoJawFull: {
				value: props.twoJawFull,
				isValid: false,
			},
		},
		false
	);

	useEffect(() => {
		setFormData(
			{
				stationName: {
					value: props.stationName,
					isValid: true,
				},
				oneJaw1To7: {
					value: props.oneJaw1To7,
					isValid: true,
				},
				twoJaw1To7: {
					value: props.twoJaw1To7,
					isValid: true,
				},
				oneJaw7To14: {
					value: props.oneJaw7To14,
					isValid: true,
				},
				twoJaw7To14: {
					value: props.twoJaw7To14,
					isValid: true,
				},
				twoJaw14To21: {
					value: props.twoJaw14To21,
					isValid: true,
				},
				twoJaw21To28: {
					value: props.twoJaw21To28,
					isValid: true,
				},
				oneJawFull: {
					value: props.oneJawFull,
					isValid: true,
				},
				twoJawFull: {
					value: props.twoJawFull,
					isValid: true,
				},
			},
			true
		);
		setIsLoading(false);
	}, [setFormData, props.open]);

	//editing the specified station
	const stationUpdateHandler = (event) => {
		setIsLoading(true);
		axios
			.put(
				"/api/v1/laboratorys/update-orderType-process",
				{
					id: props.id,
					stationName: formState.inputs.stationName.value,
					oneJaw1To7: formState.inputs.oneJaw1To7.value ?? "0",
					twoJaw1To7: formState.inputs.twoJaw1To7.value ?? "0",
					oneJaw7To14: formState.inputs.oneJaw7To14.value ?? "0",
					twoJaw7To14: formState.inputs.twoJaw7To14.value ?? "0",
					twoJaw14To21: formState.inputs.twoJaw14To21.value ?? "0",
					twoJaw21To28: formState.inputs.twoJaw21To28.value ?? "0",
					oneJawFull: formState.inputs.oneJawFull.value ?? "0",
					twoJawFull: formState.inputs.twoJawFull.value ?? "0",
				},
				{
					headers: {
						"Content-Type": "application/json",
						authorization: auth.token,
					},
				}
			)
			.then((response) => {
				dispatch({
					type: "update_order_process",
				});
				props.close();

				enqueueSnackbar(response.data.message.message, {
					variant: "success",
				});
			})
			.catch((e) => {
				const messages = e.response.data.message.message;

				if (!Array.isArray(messages)) {
					enqueueSnackbar(messages, { variant: "error" });
				} else {
					messages.map((message) => {
						enqueueSnackbar(message, { variant: "error" });
					});
				}
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<React.Fragment>
			<Paper sx={{ flexGrow: 1, maxWidth: 1200, p: 2 }}>
				{isLoading ? (
					<div style={{ justifyContent: "center", display: "flex" }}>
						<CircularProgress color="inherit" />
					</div>
				) : (
					<form onSubmit={stationUpdateHandler}>
						<Grid container spacing={2}>
							<Grid md={12} xs={12}>
								<Input
									id="stationName"
									element="input"
									label="نام مرحله کاری"
									validators={[VALIDATOR_REQUIRE()]}
									errorText="لطفا نام مرحله کاری را وارد کنید."
									onInput={inputHandler}
									initialValue={
										formState.inputs.stationName.value
									}
									inputValid={
										formState.inputs.stationName.isValid
									}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="oneJaw1To7"
									element="number_only"
									label="1 تا 7 واحد، یک فک"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									onInput={inputHandler}
									type="text"
									errorText="لطفا یک عدد وارد کنید"
									initialValue={
										formState.inputs.oneJaw1To7.value
									}
									inputValid={
										formState.inputs.oneJaw1To7.isValid
									}
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJaw1To7"
									element="number_only"
									label="1 تا 7 واحد، دو فک"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									onInput={inputHandler}
									type="text"
									errorText="لطفا یک عدد وارد کنید"
									initialValue={
										formState.inputs.twoJaw1To7.value
									}
									inputValid={
										formState.inputs.twoJaw1To7.isValid
									}
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="oneJaw7To14"
									element="number_only"
									label="7 تا 14 واحد، یک فک"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									onInput={inputHandler}
									type="text"
									errorText="لطفا یک عدد وارد کنید"
									initialValue={
										formState.inputs.oneJaw7To14.value
									}
									inputValid={
										formState.inputs.oneJaw7To14.isValid
									}
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJaw7To14"
									element="number_only"
									label="7 تا 14 واحد، دو فک"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									onInput={inputHandler}
									type="text"
									errorText="لطفا یک عدد وارد کنید"
									initialValue={
										formState.inputs.twoJaw7To14.value
									}
									inputValid={
										formState.inputs.twoJaw7To14.isValid
									}
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJaw14To21"
									element="number_only"
									label="14 تا 21 واحد ، دو فک"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									onInput={inputHandler}
									type="text"
									errorText="لطفا یک عدد وارد کنید"
									initialValue={
										formState.inputs.twoJaw14To21.value
									}
									inputValid={
										formState.inputs.twoJaw14To21.isValid
									}
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJaw21To28"
									element="number_only"
									label="21 تا 28 واحد ، دو فک"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									onInput={inputHandler}
									errorText="لطفا یک عدد وارد کنید"
									type="text"
									initialValue={
										formState.inputs.twoJaw21To28.value
									}
									inputValid={
										formState.inputs.twoJaw21To28.isValid
									}
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="oneJawFull"
									element="number_only"
									label="یک فک کامل"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									onInput={inputHandler}
									errorText="لطفا یک عدد وارد کنید"
									type="text"
									initialValue={
										formState.inputs.oneJawFull.value
									}
									inputValid={
										formState.inputs.oneJawFull.isValid
									}
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid md={3} xs={6}>
								<Input
									id="twoJawFull"
									element="number_only"
									label="دو فک کامل"
									validators={[
										VALIDATOR_VALIDATED(),
										VALIDATOR_NUMBER_ONLY(),
									]}
									onInput={inputHandler}
									errorText="لطفا یک عدد وارد کنید"
									type="text"
									initialValue={
										formState.inputs.twoJawFull.value
									}
									inputValid={
										formState.inputs.twoJawFull.isValid
									}
									needsThousandSeparator
									inputProps={{ min: 0 }}
								/>
							</Grid>
							<Grid xs={12} md={6}>
								<Button
									type="submit"
									disabled={!formState.isValid}
									fullWidth
									color="secondary"
									variant="contained"
								>
									<EditIcon />
								</Button>
							</Grid>
							<Grid xs={12} md={6}>
								<Button
									fullWidth
									color="primary"
									variant="contained"
									onClick={props.close}
								>
									<ArrowBackIcon />
								</Button>
							</Grid>
						</Grid>
					</form>
				)}
			</Paper>
		</React.Fragment>
	);
};

export default EditStation;
